const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
let sections = document.querySelectorAll('.c-section');
let body = document.querySelector('body');
let checkboxImg = document.getElementById('checkbox-img');
let checkboxCV = document.getElementById('checkbox-cv');

if(sections){
  sections.forEach((section) => {
  
    section.addEventListener('click', () => {
  
      if (section.classList.contains('active')) {
          section.classList.remove('active');
      } else {
          sections.forEach((section) => {
              section.classList.remove('active');
          });
          section.classList.add('active');
      }
  
    });
  });
}


//////////////////////// Images Uploads in update page
if(urlParams.has('edit-profile') == true) {
  let imageInput = document.querySelector('#user_image');
  let cvInput = document.querySelector('#user_cv');

  imageInput?.addEventListener('change', function(){
    var reader = new FileReader();
    let userImgContainer = document.getElementById('user-img');
    let userImg = document.querySelector('#user-img > img');

    if(userImg){
      reader.onload = function(e) {
        document.querySelector('#user-img > img').src = e.target.result;
      }
    } else {
      userImgContainer.innerHTML = '<img src="" alt="Image de profil" class="attachment-thumbnail size-thumbnail">'
      reader.onload = function(e) {
        document.querySelector('#user-img > img').src = e.target.result;
      }
    }

    reader.readAsDataURL(this.files[0]);

    //check the checkbox if the image file is empty or removed
    if(imageInput.value == ""){
      checkboxImg.checked = true;
    } else {
      checkboxImg.checked = false;
    }
  })

  cvInput?.addEventListener('change', function(event){
    var input = event.target;
    var fileName = input.files[0].name;
    let userCVContainer = document.querySelector('#user-doc > .user-doc-link');
    let userCV = document.querySelector('#user-doc > .user-doc-link > a');

    if(!userCV){
      console.log('')
      userCVContainer.innerHTML = '<a href="#" target="_blank"></a>';
    }

    console.log('')
    document.querySelector('#user-doc > .user-doc-link > a').href = "#";
    document.querySelector('#user-doc > .user-doc-link > a').textContent = fileName;

    //check the checkbox if the cv file is empty or removed
    if(cvInput.value == ""){
      checkboxCV.checked = true;
    } else {
      checkboxCV.checked = false;
    }
  })

  //button for remove image
  let removeImage = document.getElementById('remove-img');
  removeImage?.addEventListener('click', function(){
    
    //remove image from input
    imageInput.value = "";

    let userImg = document.getElementById('user-img');
    checkboxImg.checked = true;

    userImg.innerHTML = '<div class="img-placeholder"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6"><path stroke-linecap="round" stroke-linejoin="round" d="M6.827 6.175A2.31 2.31 0 015.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 00-1.134-.175 2.31 2.31 0 01-1.64-1.055l-.822-1.316a2.192 2.192 0 00-1.736-1.039 48.774 48.774 0 00-5.232 0 2.192 2.192 0 00-1.736 1.039l-.821 1.316z" /><path stroke-linecap="round" stroke-linejoin="round" d="M16.5 12.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM18.75 10.5h.008v.008h-.008V10.5z" /></svg></div>';


  })

  //button for remove cv  
  let removeCv = document.getElementById('remove-cv');
  removeCv?.addEventListener('click', function(){
    document.querySelector('#user-doc > .user-doc-link > a').href = "#";
    document.querySelector('#user-doc > .user-doc-link > a').textContent = "";

    checkboxCV.checked = true;
  })
}


//////////////////////// Publication member profile (tabs section)
if(urlParams.has('edit-profile') == false) {

  let tabs = document.querySelectorAll('.tabs .tabs-nav li')
  let tabsContent = document.querySelectorAll('.publications .publi-list')
  let tabArticles = document.getElementById('tab-articles')
  let dataArticles = document.querySelector('[data-tab="tab-articles"]')

  if(tabArticles)
    tabArticles.classList.add('tab-active')
  
  if(dataArticles)
    dataArticles.classList.add('active')


  tabs?.forEach((tab) => {

    tab.addEventListener('click', () => {

      let tabData = tab.getAttribute('data-tab')
      let content = document.getElementById(tabData)

      tabs.forEach((tab) => {
        tab.classList.remove('active')
      });
      tabsContent.forEach((tabContent) => {
        tabContent.classList.remove('tab-active')
      });

      content.classList.add('tab-active')
      tab.classList.add('active')
    })

  })

};


//// Display or undisplay input in function of checkbox
let checkboxAchievement = document.getElementById('achievements-choice');
// let halInput = document.getElementById('hal_input');
let halID = document.getElementById('hal_id');

if(checkboxAchievement){

  if(checkboxAchievement.checked){
    // halInput.style.display = "none";
    halID.style.display = "block";
  } else {
    // halInput.style.display = "block";
    halID.style.display = "none";
  }

  checkboxAchievement.addEventListener('change', function(){
    if(this.checked){
      // halInput.style.display = "none";
      halID.style.display = "block";
    } else {
      // halInput.style.display = "block";
      halID.style.display = "none";
    }
  })
}



// Tooltip
// let tooltipBtn = document.getElementById('tooltip-leo-hal')
// let tooltipContent = document.getElementById('tooltip-hal-content')

// if(tooltipBtn){
//   tooltipBtn.addEventListener('click', function(){
//     tooltipContent.classList.toggle('active')
//   })
// }